import React from "react";
import "./styles.css";

const TermsAndCondition = () => {
  return (
    <React.Fragment>
      <span className="root">
        <span className="header">TREND AnyWARE® 软件最终用户许可协议</span>

        <span className="lineBreak">
          通过点击下面的“接受”按钮，您同意对您产生约束的本 EULA 条款
        </span>

        <span className="lineBreak">
          本最终用户许可协议，包括我们可能根据第 12 条不时进行的修改（下称
          <b>“EULA”</b>）是您（个人或单个实体）与 TREND Networks Limited（下称“
          <b>TREND</b>
          ”）之间签署的一份具有法律约束力的协议，适用于您访问和使用 EULA 附随的
          TREND AnyWARE®
          软件，可能包括相关媒体、印刷材料、“在线”或电子文档以及基于互联网的服务（下称
          <b>“软件”</b>） 。通过该软件，您能够与兼容的 TREND
          测试设备、装置和工具（下称<b>“工具”</b>
          ）连接并访问数据。可以使用任何设备上的 Web
          浏览器访问软件，也可以将软件下载并安装到计算机上。
        </span>

        <span className="lineBreak">
          <b>重要提示 - 请仔细阅读本 EULA 条款。</b>
          它包含影响您和您使用软件的重要条款，并且需要您在履行 EULA
          时根据当前版本的 EULA 对其进行评估。
          通过创建帐户、安装或以其他方式访问或使用软件或其任何部分，即表明您同意，您已阅读、理解并同意以您自己的名义，
          以及在适用情况下，以雇用您或您所代表的公司或实体的名义，受 EULA
          条款的约束。如果您不同意，请不要访问、
          安装、复制或使用软件；如果您不同意对 EULA
          的任何修改，您将不再拥有访问或使用软件的任何权利或许可，您应立即卸载和/或停止访问或使用软件。
        </span>

        <span className="lineBreak">
          您声明并保证，您是在经营您的业务的过程中或者为业务目的（而不是作为消费者）而达成
          EULA。 然而，如果根据适用法律将适用任何消费者法律，那么 EULA
          不影响或损害您在适用法律下可能享有的任何法定消费者权利。
          如果您是代表公司或其他法律实体达成
          EULA，则您声明并保证，您有权让此类公司或实体接受 EULA
          条款的约束，在这种情况下，
          “您”还应指您所代表或受雇的公司或实体、其关联公司及其董事、高级职员、员工、代理和代表。
        </span>

        <ol>
          <li>
            <b>软件的使用</b>
            <ol>
              <li>
                如果您遵守本 EULA 条款，TREND
                将授予您一项非排他性、不可转让、不可转授、可撤销、权利和许可有限、供您在您拥有或控制的设备上下载、
                安装、激活、访问或以其他方式使用软件的目标代码版本，并且仅用于
                EULA 允许的内部操作。
              </li>
              <li>
                您可准许您公司或组织内的第三方和/或用户（下称<b>“获准用户”</b>
                ）在日常工作过程中访问及使用软件，其中此类使用仅： (i)
                代表您自己；(ii) 为了您的内部运营；以及 (iii) 符合本
                EULA。您将确保所有获准用户同意遵守本 EULA 的条款和通知，
                而且已知悉并同意 TREND 在向您的获准用户提供软件访问权之前，按照
                TREND 的隐私政策条款来收集、使用和分享个人信息。 EULA
                中提及的所有“您”或“您的”也应被解释为您的获准用户。您负责：(a)
                识别和验证所有获准用户的身份；(b) 批准此类获准用户访问软件； (c)
                确保获准用户遵守本 EULA；(d) 控制获准用户未经授权访问或使用；(e)
                维持用户名、密码和帐户信息的机密性；以及 (f)
                根据适用法律的要求，
                向获准用户提供或从获准用户处获得其任何必要的通知或同意，包括但不限于在激活工具上的位置跟踪功能之前。TREND
                对于您的获准用户造成的任何损害概不负责，
                其中包括未被授予软件访问权限，但是由于您或您的代表在您的本地身份管理基础设施、本地设备中或其他情况下未及时终止用户名、密码或帐户的使用
                ，而使其具有访问权限的个人。您对使用您的及您的获准用户的用户名、密码或帐户进行的或与之相关的所有活动，或者由于您及您的获准用户访问软件而产生的活动负责
                ，并同意立即以书面形式通知 TREND
                任何未经批准的使用。您同意尽一切合理努力防止未经授权的第三方访问软件。您对任何获准用户的一切作为或不作为负责，
                并且应向 TREND 赔偿 TREND
                因任何获准用户的作为或不作为而产生或遭受的，或者 TREND
                可能负责承担的所有成本、费用、索赔、损失或损害（不论是直接的、
                间接的还是后果性的，并且包括任何经济损失或其他利润、业务或商誉的损失）。
              </li>
              <li>
                您必须指定一个或多个获准用户作为您的帐户管理员（下称
                <b>“管理员”</b>）。
                您同意，管理员可以代表您在任何时间以任何理由授予和撤销其他获准用户的访问权限和使用权。您可以通过更新您的指定，随时以任何理由更换您的管理员。
              </li>
              <li>
                您同意，您对（并且 TREND
                不向您或任何第三方负责）您使用软件、违反您在本 EULA
                项下义务的任何行为， 以及任何此类违约产生的后果（包括 TREND
                可能遭受的任何损失或损害）负责。
              </li>
              <li>
                您可以使用 Web 浏览器在您的设备上访问软件。可以在运行 Microsoft
                Windows 操作系统的计算机上下载并安装一个独立版本。
                独立版本允许通过直接连接而不是通过互联网与工具进行通信。
              </li>
              <li>
                为了下载、安装、激活、访问或以其他方式使用软件，您需要注册一个帐户。TREND
                保留自行决定拒绝任何注册的权利。作为您使用软件的对价，
                您同意：(i) 提供准确、最新和完整的帐户信息；(ii)
                维护并及时更新您的帐户信息；(iii)
                维护您的密码的安全性，并且承担未经授权访问您的帐户及您向 TREND
                提供的信息的一切风险；以及 (iv)
                如您发现或以其他方式怀疑任何与软件或您使用软件有关的安全漏洞，请立即通知我们。
              </li>
              <li>
                为了使 TREND 能够承担软件的服务、维护和支持，您应向 TREND 授予
                TREND 所需的访问权限，以便使 TREND
                能够登录您的帐户并像您一样操作您的帐户。
                此类授权访问权限包括查看、修改和删除您的数据的权利。
              </li>
              <li>
                在法律允许的范围内，只要您的任何作为或不作为不符合本 EULA，TREND
                就可以删除您的任何数据。TREND 将尝试在删除您的数据之前通知您，
                但如果未发出通知做，也不构成违反本
                EULA。如果您从我们或我们的第三方服务器下载并删除了您的数据，
                那么这些下载和删除的数据将不再能够通过软件或我们或我们的第三方服务器访问。
              </li>
              <li>
                您完全负责自费提供和维护使用软件和工具所需的所有工具、设备、软件、服务和其他物品（包括但不限于任何计算机或设备硬件或软件、调制解调器、电话服务和互联网访问）。
              </li>
              <li>
                您确认，您使用软件可能需要连接互联网，并且您可能在使用软件时发生与您的设备传输（不论是发送还是接收）的信息相关的数据费用。任何此类数据费用均由您自行承担。
              </li>
            </ol>
          </li>

          <li>
            <b>保留权利和所有权</b>
            <ol>
              <li>
                软件是通过许可而非出售的方式提供给您，您仅能根据本 EULA
                的条款使用软件。对以下各项享有的产权、所有权和所有权利： (i)
                软件（包括但不限于所有知识产权）；以及 (ii) TREND
                或我们的第三方许可方提供的所有内容和其他材料， 包括但不限于
                TREND 和 TREND AnyWARE®
                徽标及其所有设计、文字、图形、图片、信息、数据、软件、声音文件、
                其他文件及其选择和安排（统称“内容”）的产权、所有权和全部权利是
                TREND 或我们的许可方（如有）的专有财产，
                受版权和其他知识产权及适用法律保护，并应始终属于 TREND。TREND
                保留本 EULA
                中未明确授予您的全部权利，且不授予任何其他权利，无论是明示的还是默示的。
              </li>
              <li>
                “TREND”、“TREND Networks”、“TREND AnyWARE”、“LanTEK”、“TREND
                Networks”、“FiberTEK”、“SignalTEK”、“NaviTEK”、“SecuriTEST”、“LanXPLORER”、“UniPRO
                MGig1”以及 TREND Networks 和 TREND AnyWARE®
                徽标以及任何其他可能出现在软件或内容上的 TREND
                产品或服务名称、徽标或标语都是 TREND 的商标，并且未经 TREND
                事先书面许可，不得全部或部分复制、模仿或使用，也不得使用任何混淆性相似的名称、徽标或标语。软件或内容中出现的第三方标志属于第三方所有，未经相关商标持有人许可，不得使用。未经我们事先书面许可，您不得使用任何利用“TREND”或
                TREND
                的任何其他名称、商标、产品或服务名称的元标签或其他“隐藏文本”。此外，软件的外观，包括所有页标题、自定义图形、按钮图标和脚本，均为
                TREND
                的服务标志、商标和/或商业外观，未经我们事先书面许可，不得全部或部分复制、模仿或使用。通过名称、商标、制造商、供应商或其他方式引用任何产品、服务、流程或其他信息，并不构成或默示
                TREND 对此类产品、服务、流程或其他信息的背书、赞助或推荐。
              </li>
            </ol>
          </li>

          <li>
            <b> 限定和限制 </b>
            <ol>
              <li>
                您理解并同意，您只能以符合您使用软件时所在司法管辖区的所有适用法律的方式使用软件。如果您违反本
                EULA，您可能会面临起诉并作出损害赔偿。
              </li>
              <li>
                您不会并且也不会容许任何第三方：
                <ol>
                  <li>
                    在不属于您或您不能依法控制的任何设备上下载、安装、激活、访问或以其他方式使用软件或内容；
                  </li>
                  <li>
                    发表、讨论、发布、广播或以其他方式向任何第三方传播通过使用工具获得的任何测试结果；
                  </li>
                  <li>
                    翻译、合并、改编、改变、变更或修改软件的全部或任何部分，也不允许软件的任何部分与任何其他程序合并或被纳入其他程序；
                  </li>
                  <li>
                    对软件的全部或任何部分进行反向工程、反编译、试图获得源代码、修改或反汇编，但在适用法律明确允许的范围内进行的除外；
                  </li>
                  <li>移除或更改软件上的任何专有通知或标记；</li>
                  <li>基于软件的整体或任何部分创作衍生作品；</li>
                  <li>在您的组织之外复制或重制软件；</li>
                  <li>
                    未经 TREND
                    事先书面同意，以任何形式将全部或部分软件出售、转让、许可、分发、出租、租赁、转授、出借、提供或以其他方式提供给任何人；
                  </li>
                  <li>
                    以任何非法方式、为任何非法目的或以任何与该等条款不一致的方式使用软件，或做出欺诈或恶意行为，例如，侵入或将病毒或有害数据等恶意代码插入软件或任何操作系统；
                  </li>
                  <li>
                    侵犯我们的知识产权或任何与您使用软件有关的第三方的知识产权，包括通过提交任何材料（在此类使用未获得这些条款许可的情况下）；
                  </li>
                  <li>
                    传输与您使用软件有关的任何诽谤、冒犯或其他令人反感的材料；
                  </li>
                  <li>
                    以任何可能损坏、禁用、覆盖或损害软件（或连接到软件的服务器或网络）的方式使用软件；
                  </li>
                  <li>
                    以任何可能妨碍他人使用及享用软件（或连接到软件的服务器或网络）的方式使用软件；
                  </li>
                  <li>
                    未经 TREND
                    事先书面同意，开发与软件交互的任何第三方应用程序；
                  </li>
                  <li>
                    通过使用软件或 TREND
                    的系统收集或获取任何信息或数据，或试图破译与运行软件的服务器之间的任何往返传输；或
                  </li>
                  <li>
                    将软件用于软件设计或预期目的之外的目的，或用于本协议所述以外的任何目的。
                  </li>
                </ol>
              </li>
            </ol>
          </li>

          <li>
            <b>收集和使用数据</b>
            <ol>
              <li>
                您同意，TREND
                及其附属公司可以收集和使用作为向您提供的产品支持服务（如有）的一部分而收集到的、
                与软件有关的技术信息。TREND
                仅可将这些信息用于改进我们的产品或向您提供定制服务或技术，不会以能够识别您个人身份的形式披露这些信息。
              </li>
              <b className="subHeading">个人数据</b>
              <li>
                您确认，当您下载、安装、激活、访问或以其他方式使用软件时，TREND
                可能会使用自动方式（包括，例如 cookie 和网络信标）
                收集关于您的设备和您使用软件情况的信息。您和您的获准用户可能还需要提供某些个人信息，作为下载、安装、激活、访问或使用软件或其某些特性或功能的条件。
                根据数据保护法，我们需要向您提供某些信息，包括我们的身份、我们处理您的个人数据的方式和目的，以及您对您的个人数据享有的相关权利和行使该等权利的途径。
                您可以在 TREND 的隐私政策（下称<b>“隐私政策”</b>，网址为：
                <a
                  href="https://www.trend-networks.com/cn/privacy-policy/"
                  target="_blank"
                >
                  <b>
                    https://www.trend-networks.com/cn/privacy-policy/
                  </b>
                </a>
                ,
                中看到这些信息，请您务必阅读隐私政策，它可能会不时更新，恕不另行通知。通过下载、安装、激活、访问或使用软件，
                以及向软件提供或通过软件提供信息，您同意 TREND
                根据隐私政策对您的信息进行的所有使用和行动。
              </li>
              <li>
                请注意，互联网传输从来都不是完全私密或安全的，您使用软件发送的任何消息或信息都可能被其他人读取或拦截，即使特别声明某个特定传输已加密。
              </li>
              <b className="subHeading">最终用户数据</b>
              <li>
                在涉及软件时，TREND
                可能会收集和保存由您或代表您通过软件输入或上传的数据，包括但不限于与您使用本工具以及与获准用户有关的信息
                （下称<b>“最终用户数据”</b>
                ）。您拥有所有最终用户数据，并同意对最终用户数据全权负责。TREND
                应根据私隐政策，
                对所有最终用户数据的所有可识别个人身份方面加以保密。TREND
                授权的所有可能接触最终用户数据的第三方均负有保密义务，
                并且需要遵守所有相关的数据保护法律。您同意并特此向 TREND
                授予一项不可撤销的、永久的、免版税的、可转让的和可转授的权利和许可，
                供其使用、复制、修改、改编、翻译、披露、商业化、转让、传送、出售、出租、许可或传输全部或部分最终用户数据，
                前提是它不包含任何个人数据。通过使用软件上传或传输最终用户数据，您声明并保证：(i)
                此类最终用户数据不受任何第三方保密义务的约束， 其中在根据本 EULA
                条款使用此类最终用户数据时将违反此类义务；(ii)
                您拥有并控制您创建、上传或传输的最终用户数据的全部权利，
                或您在其他方面拥有使用软件创建、上传或传输此类最终用户数据的所有必要权利；(iii)
                最终用户数据是准确的，并无任何误导或有害之处；以及 (iv)
                最终用户数据，以及您使用、上传和传输最终用户数据，现在没有并且将来也不会违反本
                EULA 的条款或任何适用法律、规则或法规。尽管 EULA
                有任何其他条款，但 TREND 可随时：(a) 删除任何最终用户数据和/或
                (b)
                暂停您的帐户和对软件的访问权限。您应确保，您保留通过软件上传、
                传输或提交给 TREND 的所有最终用户数据的副本，并且 TREND
                对您的任何最终用户数据的丢失或软件的任何使用损失不承担任何责任。
              </li>
              <b className="subHeading">TREND 数据 </b>
              <li>
                所有产生于、派生于、基于或涉及到最终用户数据的信息，包括但不限于数据、分析、测量、报告、趋势和度量（下称
                <b>“TREND 数据”</b>），都是 TREND 的专有财产。TREND
                有权以任何形式、为了任何目的以及通过任何方式使用、收集、储存、创建、聚合、挖掘、分析、修改、商业化、转让、传递、出售、出租、许可或传输
                TREND 数据。
              </li>
            </ol>
          </li>

          <li>
            <b>更新</b>
            <ol>
              <li>
                5.1 TREND
                可以在未通知的情况下修改软件，包括但不限于修改软件的功能或外观。
              </li>
              <li>
                5.2 TREND
                可以不时自行决定开发和提供软件更新，其中可能包括升级、漏洞修复、补丁和其他错误纠正和/或新功能（包括相关文件，统称
                <b>“更新”</b>）
                。更新也可能是完全修改或删除某些特性和功能。您同意，TREND
                没有义务提供任何更新，也没有义务继续提供或启用任何特定特性或功能。
                根据您的设备设置，当您的设备连接到互联网时：(i)
                软件将自动下载和安装所有可用的更新；或者 (ii)
                您可能会收到通知或系统提示，
                要求您下载和安装可用的更新。为了能够充分利用软件，您必须及时下载和安装所有更新。您确认，如果您未能正确操作该软件或其部分，
                则该软件或其部分可能无法正常运行。您进一步同意，所有更新将被视为软件的一部分，受本
                EULA 的所有条款和条件的约束。
              </li>
            </ol>
          </li>

          <li>
            <b> 第三方网站的链接与支持</b>
            <ol>
              <li>
                您可以通过软件链接到第三方网站（例如链接到“Team
                Viewer”、远程桌面支持平台和外部标签打印机）。第三方网站不受
                TREND 的控制，并且 TREND
                不对任何第三方网站的内容、第三方网站中包含的任何链接或对第三方网站的任何更改或更新负责。TREND
                不对从任何第三方网站接收的网络广播或任何其他形式的传输负责。TREND
                向您提供第三方网站的链接仅为了便于您使用，包含任何链接并不意味着
                TREND 对第三方网站的认可。
              </li>
              <li>
                如欲了解关于软件的更多信息或有任何软件使用问题，请访问
                <a
                  href="https://www.trend-networks.com/in/en/index.aspx"
                  target="_blank"
                >
                  <b>www.trend-networks.com</b>
                </a>{" "}
                获取区域电子邮箱和电话联系方式。根据本 EULA，TREND
                无需提供任何支持服务。如果您需要任何支持，将按您的请求提供支持，并按时间和成本收取费用。本
                EULA 未授予您享有软件的任何更新或升级的权利，也未授予您享有
                TREND
                或其代表在未来任何时候开发的软件的任何扩展或增强的权利。TREND
                可以单独提供支持服务。作为任何支持服务的一部分，TREND
                向您提供的任何补充软件代码或相关材料将被视为软件的一部分，并受
                EULA 条款和条件的约束。
              </li>
            </ol>
          </li>

          <li>
            <b> 机密信息 </b> <br />
            您确认并同意，软件（不包括任何开源软件）以及以任何形式源自软件和
            TREND 业务的所有信息均为 TREND 的宝贵知识产权，并被视为 TREND
            的机密信息（下称<b>“机密信息”</b>）。您同意，在本 EULA
            期限内或之后，您不允许复制、
            使用或向任何人披露任何此类机密信息，除非此类复制、使用或披露已事先得到
            TREND
            的明确书面授权。您应尽合理的努力防止未经授权披露或复制机密信息，
            并且在任何情况下应采取不低于您对自有的类似性质的机密信息所采取的谨慎程度。在不限制上述条款的普遍性的前提下，当
            EULA 允许复制机密信息时
            ，所有此类副本均应具有与原始版本中出现的相同的机密通知、图例和知识产权标识，且各方应详细记录所有机密信息的位置。
          </li>

          <li>
            <b>终止 EULA 的权利</b>
            <ol>
              <li>
                EULA 将持续适用，直至您或 TREND 根据此处的条款终止本 EULA。
              </li>
              <li>
                您可以随时通过停止访问软件和/或从您的计算机上永久卸载软件来终止本
                EULA。
              </li>
              <li>
                如果您未能遵守 EULA 的任何条款，您的权利将立即自动终止，无需
                TREND
                发送通知。在这种情况下，您必须立即停止访问软件，并且/或者卸载软件。
              </li>
              <li>
                TREND
                可以随时终止您使用软件的权利，无论是否事先通知。与数据使用、赔偿、责任限制、保密、争议解决以及协议构建和订立有关的
                EULA 条款，在 EULA 终止或届满后仍然有效。
              </li>
            </ol>
          </li>

          <li>
            <b>赔偿 </b>
            <br />
            在法律允许的最大范围内，您同意为
            TREND、其子公司及关联公司及其各自的董事、高级职员、员工及代理辩护，向其赔偿并且使其免予承担因为您（或利用您的帐户或密码行事的任何人）使用软件（包括您访问和/或安装或使用软件）或您违反本
            EULA
            的行为而产生的任何及所有索赔、诉讼、起诉或程序，以及任何和所有损失、责任、损害赔偿、成本及开支（包括合理的律师费）。
          </li>

          <li>
            <b>责任限制</b>
            <ol>
              <li>
                如果不合法，TREND
                不会以任何方式排除或限制其对您承担的责任。这包括因 TREND
                或其员工、代理或分包商的疏忽或欺诈或虚假陈述而造成的死亡或人身伤害的责任。
              </li>
              <li>
                您明确理解并同意，您使用软件的行为完全由您自行决定并自行承担风险，而且软件是“按原样”和“现有情况”提供的，未作出任何明示或默示的保证。因该等使用而导致您的计算机或其他设备的任何损坏或数据丢失，均由您自行负责。TREND
                进一步明确否认任何其他类型的保证和条件，无论是明示的还是默示的，包括但不限于关于软件的适销性、适用于特定用途和非侵权的默示保证和条件。一些司法管辖区不允许放弃或排除模式保证，因此它们可能不适用于您。TREND
                不保证在您享用软件时不产生干扰、软件所包含的功能或执行或提供的服务将满足您的要求、软件或服务的运行将不间断或无错误，或者软件或服务中的缺陷将得到纠正。TREND
                或其授权代表提供的任何口头或书面信息或建议均不构成保证。
              </li>
              <li>
                您明确理解并同意，除涉及第 10.1 条外，在任何责任理论下，TREND
                及其附属公司、关联公司及其许可方均不向您承担任何性质或金额的任何损失或损害，不论此类损失或损害是直接、间接、附带、特殊、后果性还是惩戒性的损害，无论您是否因使用软件而遭受或招致此类损失或损害（包括任何数据的丢失或对您的设备的损坏），并且不论您或您的代表是否已知悉或本应知悉任何此类损失的可能性。
              </li>
              <li>
                请备份与软件一起使用的内容和数据。TREND
                建议您备份与软件有关的任何内容和数据，以便在软件出现问题时保护您自己。
              </li>
            </ol>
          </li>

          <li>
            <b>EULA 的修订 </b>
            <br />
            TREND
            可随时向您发送通知（无论是通过电子邮件、在线、通过软件或其他方式）并在通知中指明修订内容，以此修订
            EULA（包括对您使用软件应支付的费用的修订），并且此类修订应被视为在此类通知之日起三十
            (30)
            天内生效。您应当承认并同意通知书所指明的修订。如未能确认并同意此类修订，TREND
            有权在向您提前一 (1) 个月发送通知后终止 EULA。
          </li>

          <li>
            <b>通知 </b>
            <ol>
              <li>
                根据本 EULA
                或与其有关的、向一方发送的任何通知或其他通信均应采用书面形式，并应亲自递送或通过预付费一类邮件或者通过其他次日达（下一个工作日）递送服务送至其注册办事处（若是公司）或其主要营业地点（在任何其他情况下）。
              </li>
              <li>
                在以下情况中，任何通知或通信应被视为已送达：(i)
                如果亲自递送，应在交付收据上签字，或在通知被交付至适当地址时视为送达；(ii)
                如果通过预付费一类邮件或者通过其他次日达递送服务发送，则在投寄后的第二个工作日上午
                9.00 或者快递服务记录的时间视为已送达；以及 (iii)
                如果通过电子邮件发出，则在传送时，或者如果该时间不在接收者地点的营业时间内，则在营业时间恢复时（即周一至周五上午
                9.00 至下午 5.00，并且接收地点不处于公共假日）视为已送达。
              </li>
            </ol>
          </li>

          <li>
            <b> 适用法律和管辖权 </b>本 EULA 以及因 EULA
            或其标的事项或其订立而产生或与其相关的任何争议或索赔（包括非合同争议或索赔）应受英格兰及威尔士法律管辖并按该法律解释，双方不可撤销地同意，英格兰和威尔士法院对因本
            EULA
            或其标的事项或其订立而产生或与其有关的任何争议或索赔（包括非合同争议或索赔）具有专属管辖权。
          </li>

          <li>
            <b>其他</b>
            <br />本 EULA（包括 EULA 的任何附录或修订）是您与 TREND
            之间关于软件和支持服务（如有）的完整协议，它取代所有先前或同时发生的、与
            EULA
            所涵盖的软件或任何其他标的事项有关的口头或书面通信、建议和陈述。如果
            TREND 的任何政策的条款或支持服务的条款与本 EULA 条款冲突，则以本
            EULA 的条款为准。如果本 EULA
            的任何条款被认为是无效、失效、不可执行或非法，则此类条款将被视为已进行重述，以最大限度地反映双方的原始意图，并且根据适用的法律，其他条款应继续完全有效。TREND
            未能行使或执行本 EULA
            的任何权利或规定，不构成对此类权利或规定的弃权，除非 TREND
            书面确认并同意。双方之间的行为过程或交易惯例均不得对本 EULA
            的任何条款作出修改。未经 TREND 事先书面同意，您不得转让本 EULA
            或您在 EULA 项下的任何权利，其中 TREND
            可自行决定授予或设定同意条件，并且未获此类同意的任何转让尝试均为无效。在遵守上述限制的前提下，本
            EULA 将完全具有约束力，保障 TREND
            和我们各自的继任人和受让人的利益，并可强制执行。TREND
            可以将其在这些条款项下的权利和义务转让给其他组织。
          </li>
        </ol>
      </span>
    </React.Fragment>
  );
};

export default TermsAndCondition;
